'use client';

import EntryServiceLayout from '@/components/layout/service/EntryServiceLayout';

interface EntryLayoutProps {
    children: React.ReactNode;
}

export default function layout({ children }: EntryLayoutProps) {
    return <EntryServiceLayout>{children}</EntryServiceLayout>;
}
